// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__33IZ7","title":"AfterFrontImage_title__22LxK"};